export default __webpack_public_path__ + "static/media/NR-BX471GPKA 2.583bae90.jpg";